import styled from 'styled-components';

export const Embed = styled.embed`
	height: 100%;
	width: 100%;
`;
